
import styled from "styled-components";



export const Flex = styled.div`
display:flex;
flex-direction:column;
`



export const ViewAllProjectsButtonContainer = styled(Flex)`
flex-direction:row;
justify-content:center;
align-items:center;
margin:0 auto;

& a {
    width:100%;
    padding-left:10%;
    padding-right:10%;
    
}



@media screen and (min-width: ${({ theme }) => theme.breakpoints.mobile}) {

a {
    max-width:600px;
}

}
`;


export const SocialContainer = styled(Flex)`
  justify-content: space-between;
  line-height: 2;
   
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction:row;
    a {
        padding-right:10px;
    }
  }
`;